// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "tire-recommender" + "." + "75af3581762c48c68b15" + ".min.css";
};